"use strict";

export default function setupShopArchive() {
    // pega a section real do shop (a sua)
    const scope = document.querySelector(".o-archive-shop");

    const grid = scope?.querySelector(".o-page-blog__grid");
    if (!grid) return;

    const pagination = scope.querySelector(".o-pagination");
    const countEl =
        scope.querySelector(".c-filtro-expedicoes__count") ||
        document.querySelector(".c-filtro-expedicoes__count");

    const loading = document.querySelector(".o-expedition-loading");

    function showLoading() {
        if (loading) loading.style.display = "block";
        grid.style.display = "none";
    }

    function hideLoading() {
        if (loading) loading.style.display = "none";
        grid.style.display = "";
        grid.classList.remove("is-loading");
    }

    // ===== state =====
    let currentPage = parseInt(
        new URLSearchParams(window.location.search).get("pagina") || "1",
        10,
    );
    if (!Number.isFinite(currentPage) || currentPage < 1) currentPage = 1;

    function getOrderby() {
        return (
            document.querySelector('[data-filter="orderby"]')?.dataset.value ||
            "date"
        );
    }

    const monthsEl =
        scope?.querySelector(".c-filtro-expedicoes__months") ||
        document.querySelector(".c-filtro-expedicoes__months");

    function getCategoria() {
        return monthsEl?.dataset.currentCategoria ?? "";
    }

    function setUrl(orderby, page, categoria) {
        const u = new URL(window.location.href);
        u.searchParams.set("orderby", orderby || "date");
        u.searchParams.set("pagina", String(page || 1));
        if (categoria) {
            u.searchParams.set("categoria", categoria);
        } else {
            u.searchParams.delete("categoria");
        }
        window.history.replaceState({}, "", u.toString());
    }

    function renderResponse(payload) {
        if (!payload) return;

        if (typeof payload.grid === "string") grid.innerHTML = payload.grid;

        if (pagination && typeof payload.pagination === "string") {
            pagination.innerHTML = payload.pagination;
        }

        if (countEl && typeof payload.count !== "undefined") {
            countEl.textContent = `${parseInt(payload.count || 0, 10)} itens encontrados`;
        }
    }

    function updateFilters() {
        const orderby = getOrderby();
        const categoria = getCategoria();
        const page = currentPage;

        showLoading();

        const ajaxUrl = window.ajaxurl || "/wp-admin/admin-ajax.php";

        const params = new URLSearchParams();
        params.set("action", "filtrar_produtos_shop");
        params.set("orderby", orderby);
        params.set("pagina", String(page));
        if (categoria) params.set("categoria", categoria);

        fetch(`${ajaxUrl}?${params.toString()}`, {
            method: "GET",
            credentials: "same-origin",
            headers: { "X-Requested-With": "XMLHttpRequest" },
        })
            .then((r) => r.json())
            .then((json) => {
                if (!json || !json.success) throw new Error("invalid");
                renderResponse(json.data);
                setUrl(orderby, page, categoria);
                hideLoading();
            })
            .catch(() => {
                grid.innerHTML =
                    "<p>Erro ao carregar produtos. Tente novamente.</p>";
                hideLoading();
            });
    }

    // ===== dropdown open/close (genérico) =====
    const filterItems = document.querySelectorAll(
        ".c-select, .c-filtro-expedicoes__item",
    );

    document.addEventListener("click", (e) => {
        const item = e.target.closest(".c-select, .c-filtro-expedicoes__item");
        if (!item) return;

        // só abre se clicou no "trigger" (seta, label, topo do select)
        const trigger =
            e.target.closest(".arrow") ||
            e.target.closest(".c-select__trigger") ||
            e.target.closest(".c-select__header") ||
            e.target.closest(".c-select__label") ||
            e.target.closest(".label");

        if (!trigger) return;

        const open = item.classList.contains("open");
        filterItems.forEach((i) => i.classList.remove("open"));
        if (!open) item.classList.add("open");
        e.stopPropagation();
    });

    document.addEventListener("click", () => {
        filterItems.forEach((i) => i.classList.remove("open"));
    });

    // ===== click option (orderby) =====
    document.addEventListener("click", (e) => {
        const option = e.target.closest(".option, .c-select__option");
        if (!option) return;

        const parent = option.closest("[data-filter]");
        if (!parent) return;

        const value = option.dataset.value ?? "";
        if (!value) return;

        parent.dataset.value = value;

        const label = parent.querySelector(".label, .c-select__label");
        if (label) label.innerText = option.innerText;

        parent.classList.add("selected");
        parent.classList.remove("open");

        currentPage = 1;
        updateFilters();
    });

    // ===== category drilldown navigation =====
    let categoryTree = [];
    try {
        categoryTree = JSON.parse(monthsEl?.dataset.categoryTree || "[]");
    } catch (_) {
        categoryTree = [];
    }

    // flat map: slug → { id, name, slug, children[] }
    const catMap = {};
    (function buildCatMap(cats) {
        cats.forEach((cat) => {
            catMap[cat.slug] = cat;
            if (cat.children?.length) buildCatMap(cat.children);
        });
    })(categoryTree);

    // navigation stack: each entry = { cats: [], parentSlug: string|null }
    const navStack = [{ cats: categoryTree, parentSlug: null }];

    function renderCategoryButtons(level) {
        if (!monthsEl) return;
        const { cats, parentSlug } = level;
        let html = "";

        if (parentSlug !== null) {
            html += `<button class="category-btn category-btn--back" data-action="back" data-back-value="${parentSlug}">← Voltar</button>`;
        } else {
            const allActive =
                monthsEl.dataset.currentCategoria === "" ? " is-active" : "";
            html += `<button class="category-btn${allActive}" data-value="">Todas</button>`;
        }

        cats.forEach((cat) => {
            const active =
                monthsEl.dataset.currentCategoria === cat.slug
                    ? " is-active"
                    : "";
            html += `<button class="category-btn${active}" data-value="${cat.slug}">${cat.name}</button>`;
        });

        monthsEl.innerHTML = html;
    }

    // ===== category buttons =====
    document.addEventListener("click", (e) => {
        const btn = e.target.closest(".category-btn");
        if (!btn || !monthsEl?.contains(btn)) return;

        // ── back button ──────────────────────────────────────────
        if (btn.dataset.action === "back") {
            navStack.pop();
            const level = navStack[navStack.length - 1];
            // restore parent category as the active filter
            monthsEl.dataset.currentCategoria = btn.dataset.backValue || "";
            renderCategoryButtons(level);
            currentPage = 1;
            updateFilters();
            return;
        }

        const slug = btn.dataset.value ?? "";

        // ── "Todas" at root ───────────────────────────────────────
        if (slug === "" && navStack.length === 1) {
            monthsEl.dataset.currentCategoria = "";
            renderCategoryButtons(navStack[0]);
            currentPage = 1;
            updateFilters();
            return;
        }

        // ── regular category button ───────────────────────────────
        monthsEl.dataset.currentCategoria = slug;
        const cat = catMap[slug];

        currentPage = 1;
        updateFilters();

        // drill into children if any
        if (cat?.children?.length) {
            navStack.push({ cats: cat.children, parentSlug: slug });
            renderCategoryButtons(navStack[navStack.length - 1]);
        } else {
            // no children: keep current level, just update active state
            renderCategoryButtons(navStack[navStack.length - 1]);
        }
    });

    // ===== paginação (intercepta links) =====
    document.addEventListener("click", (e) => {
        const a = e.target.closest(".o-pagination a");
        if (!a) return;

        const href = a.getAttribute("href") || "";
        if (!href) return;

        e.preventDefault();

        const u = new URL(href, window.location.origin);

        // se seu partial usa ?pagina=
        const p = parseInt(u.searchParams.get("pagina") || "1", 10);
        currentPage = Number.isFinite(p) && p > 0 ? p : 1;

        updateFilters();
    });
}
